import { fromFetch } from 'rxjs/fetch';
import { switchMap } from 'rxjs/operators';
import { getNativeInteractiveSiteMap } from 'constants/routes';

/**
 * Throws on any non-2xx response so callers can handle errors via catchError.
 * @param {Response} response
 * @returns {Promise<any>}
 */
const parseJsonResponse = (response) => {
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }
  return response.json();
};

/**
 * Fetches the SVG site map resource for a community from
 * `GET /ajax/native-interactive-site-map/{communityId}/site-plans`.
 *
 * Returns a cold Observable — the request is only made when subscribed.
 * Errors are propagated as Observable errors so the epic can handle them
 * with catchError.
 *
 * @param {number} communityId
 * @returns {import('rxjs').Observable<SiteMapResource>}
 */
export function getCommunitySiteMap$(communityId) {
  return fromFetch(getNativeInteractiveSiteMap(communityId), {
    method: 'GET',
    headers: { Accept: 'application/json' },
  }).pipe(
    switchMap(parseJsonResponse),
  );
}

export default getCommunitySiteMap$;